import React from 'react';
import { Menu as Mnu } from 'antd';
import classNames from 'classnames';
import { ChevronDown } from '@nackle/origami-icons';
/**
 * A menu component
 *
 * {@link https://ant.design/components/menu#api}
 *
 * @module Menu
 * @param {Object} props - the Menu props
 * @param {string} [props.menuSize] - the menu size
 * @returns {React.ReactElement} - a Menu
**/
export const Menu = ( { className, ...props } ) => {
    const { menuSize } = props;
    const menuClasses = classNames( {
        'menu-popover menu-sm': menuSize === 'small' ? 'menu-sm' : '',
        'menu-popover menu-lg': menuSize === 'large' ? 'menu-lg' : '',
        'menu-popover menu-md': menuSize === 'medium' ? 'menu-md' : ''
    } );
    return (
        <Mnu
            expandIcon={ <ChevronDown /> }
            { ...props } className={ className ? `${ menuClasses } ${ className }` : menuClasses }>
        </Mnu>
    );
};
